<template>
    <div v-loading="loading" style="background: white; border-radius: 5px;">
        <HeaderManageIdpExamRegister
            @openCreate="showCreate = true"
            @openImport="openImportDialog"
        />
        <hr style="padding: 0; margin: 0"/>

        <div style="padding: 15px 20px">
            <div class="grid-filter">
                <div class="display-flex-column">
                    <span>Học viên</span>
                    <el-input v-model="query.keyword" clearable placeholder="Nhập mã học viên, SĐT, tên học viên"
                              @change="handleSearch"/>
                </div>

                <div class="display-flex-column">
                    <span>Thời gian</span>
                    <el-date-picker
                        v-model="query.time_range"
                        clearable
                        end-placeholder="Đến ngày"
                        format="dd/MM/yyyy"
                        range-separator="-"
                        start-placeholder="Từ ngày"
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        @change="handleSearch"
                    />
                </div>

                <div class="display-flex-column">
                    <span>Trạng thái</span>
                    <el-select v-model="query.status" clearable collapse-tags multiple placeholder="Chọn trạng thái"
                               @change="handleSearch">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
                                   :value="item.value"/>
                    </el-select>
                </div>
            </div>

            <div class="mt-8" style="overflow-y: auto">
                <table class="table table-bordered">
                    <thead style="position: sticky; top: 0; z-index: 2">
                    <tr style="background-color: #f8f8f8">
                        <th style="min-width: 90px; text-align: start">Mã log</th>
                        <th style="min-width: 220px; text-align: start">Học viên</th>
                        <th style="min-width: 120px; text-align: start">Số điện thoại</th>
                        <th style="min-width: 160px; text-align: start">Chi nhánh</th>
                        <th style="min-width: 180px; text-align: start">Thời gian sinh tác vụ</th>
                        <th style="min-width: 90px; text-align: start">Đơn vị thi</th>
                        <th style="min-width: 110px; text-align: start">Tiền cần đóng</th>
                        <th style="min-width: 110px; text-align: start">Số tiền IDP</th>
                        <th style="min-width: 160px; text-align: start">Hình thức thanh toán</th>
                        <th style="min-width: 120px; text-align: center">Trạng thái</th>
                        <th style="min-width: 200px; text-align: start">Thời gian đóng phí</th>
                        <th style="min-width: 110px; text-align: center">Hành động</th>
                    </tr>
                    </thead>

                    <tbody v-if="records?.length > 0">
                    <tr v-for="item of records" :key="item.id" style="border: 1px solid #ebedf3; border-top: 0">
                        <td>{{ item.logCode }}</td>
                        <td style="text-align: start">{{ item.studentName }} <span
                            v-if="item.studentCode">- {{ item.studentCode }}</span></td>
                        <td style="text-align: start">{{ item.phone }}</td>
                        <td style="text-align: start">{{ item.branchName }}</td>
                        <td style="text-align: start">{{ item.taskTime }}</td>
                        <td style="text-align: start">{{ item.examUnit }}</td>
                        <td style="text-align: start">{{ formatCurrency(item.payment_amount) }}</td>
                        <td style="text-align: start">{{ formatCurrency(item.idp_payment_amount) }}</td>
                        <td style="text-align: start">{{ paymentMethodLabel(item.paymentMethod) }}</td>
                        <td style="text-align: center">
                            <span :class="item.paymentStatusClass" class="pay-status-badge">{{
                                    item.paymentStatusLabel
                                }}</span>
                        </td>
                        <td class="payment-time-cell">
                            <template v-if="item.paidAt">
                                <div class="payment-time-cell__main">{{ item.paidAtDisplay || item.paidAt }}</div>
                                <div
                                    v-if="inlineTransactionCode(item)"
                                    class="payment-tx-inline"
                                >
                                    <span class="payment-tx-inline__label">Mã GD</span>
                                    <code
                                        :title="inlineTransactionCode(item)"
                                        class="payment-tx-inline__code"
                                    >{{ inlineTransactionCode(item) }}</code>
                                </div>
                                <el-popover
                                    v-if="showPaymentHistoryPopover(item)"
                                    placement="left"
                                    popper-class="idp-payment-history-popover"
                                    trigger="click"
                                    width="420"
                                >
                                    <PaymentHistoryPanel
                                        :entries="item.paymentEntries"
                                        :show-transaction-code="isTransferMethod(item.paymentMethod)"
                                        @copy="copyText($event, 'Đã sao chép mã giao dịch')"
                                    />
                                    <button
                                        slot="reference"
                                        class="payment-history-trigger"
                                        type="button"
                                        @click.stop
                                    >
                                        <i class="el-icon-time"></i>
                                        {{ item.paymentCount }} lần
                                        <i class="el-icon-arrow-down"></i>
                                    </button>
                                </el-popover>
                            </template>
                            <span v-else class="text-muted">—</span>
                        </td>
                        <td class="text-center">
                            <button class="btn btn-icon btn-xs btn-outline-primary" title="Xem"
                                    @click="openDetail(item)">
                                <i class="el-icon-view"></i>
                            </button>
                            <button
                                v-if="item.showPaymentGuideButton"
                                class="btn btn-icon btn-xs btn-outline-danger ml-2"
                                title="Hướng dẫn thanh toán"
                                @click="openPaymentGuide(item)"
                            >
                                <i class="el-icon-money"></i>
                            </button>
                            <button
                                v-if="item.showFixPaymentButton"
                                class="btn btn-icon btn-xs btn-outline-info ml-2"
                                title="Xử lý lỗi thanh toán"
                                @click="openFixPaymentDialog(item)"
                            >
                                <i class="el-icon-warning-outline"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>

                    <tbody v-else>
                    <tr style="word-break: break-word; white-space: nowrap; position: relative; border: 1px solid #ebedf3">
                        <label style="position: absolute; left: 50%; translate: -50%; top: 10px">Không có dữ
                            liệu</label>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="records?.length > 0">
                <div class="edu-paginate mx-auto text-center mt-10 mb-5"
                     style="display: flex; justify-content: center; align-items: center; height: 50px">
                    <paginate
                        v-model="page"
                        :click-handler="changePage"
                        :container-class="'pagination b-pagination'"
                        :margin-pages="1"
                        :next-class="'page-link'"
                        :next-link-class="'next-link-item'"
                        :next-text="'Sau'"
                        :page-class="'page-item'"
                        :page-count="lastPage"
                        :page-range="3"
                        :pageLinkClass="'page-link'"
                        :prev-class="'page-link'"
                        :prev-link-class="'prev-link-item'"
                        :prev-text="'Trước'"
                    />
                </div>
                <div class="w-100" style="display: flex; justify-content: flex-end; margin-top: -50px">
                    <div>
                        Tổng số bản ghi:
                        <span style="color: #0066ff; font-weight: 600; margin-left: 5px">{{
                                total ?? records.length
                            }}</span>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            v-if="showImport"
            :show-close="false"
            :title="titleDialogImportIdp"
            :visible.sync="showImport"
            top="8vh"
            width="50%"
        >
            <hr style="padding: 0; margin-top: -20px"/>
            <DialogImportIdpExamRegister
                @closeDialog="showImport = false"
                @reload="reloadList"
                @setTitleError="setImportDialogTitle"
            />
        </el-dialog>

        <el-dialog
            v-if="showCreate"
            :close-on-click-modal="false"
            :show-close="false"
            :visible.sync="showCreate"
            append-to-body
            custom-class="dialog-idp-register"
            title="Đăng ký thi tại hội đồng cho học viên"
            width="680px"
        >
            <FormIdpExamRegister @close="showCreate = false" @created="handleCreated"/>
        </el-dialog>

        <el-dialog
            :visible.sync="showBankTransferDialog"
            append-to-body
            custom-class="seypay-dialog"
            title="Hướng dẫn thanh toán"
            width="62%"
        >
            <div class="seypay-wrapper">
                <el-alert
                    :closable="false"
                    :title="`Bước 1: Chuyển khoản theo thông tin ${bankTransferCenterName} cung cấp`"
                    class="mb-3"
                    show-icon
                    type="info"
                />

                <div class="seypay-summary">
                    <el-tag v-if="bankTransferAmount" effect="dark" type="success">
                        Số tiền: {{ formatCurrency(bankTransferAmount) }}
                    </el-tag>
                    <el-tag effect="plain" type="info">
                        Hình thức: Chuyển khoản
                    </el-tag>
                </div>

                <div v-if="bankTransferPayLink" class="seypay-paylink">
                    <div class="seypay-paylink__text">
                        Vui lòng nhắc nhở khách hàng thanh toán phí qua link:
                        <a :href="bankTransferPayLink" rel="noopener noreferrer" target="_blank">{{
                                bankTransferPayLink
                            }}</a>
                    </div>
                    <el-button plain size="mini" type="primary"
                               @click="copyText(bankTransferPayLink, 'Đã sao chép link thanh toán')">
                        Sao chép link thanh toán
                    </el-button>
                </div>

                <el-row :gutter="16" class="seypay-grid">
                    <el-col :span="10">
                        <div class="seypay-card">
                            <div class="seypay-card__title">QR thanh toán</div>
                            <div v-if="bankTransferQrCode" class="seypay-qr">
                                <img :src="bankTransferQrCode" alt="QR Code" class="seypay-qr__img"/>
                            </div>
                            <el-empty v-else :image-size="80" description="Chưa có QR"/>
                        </div>
                    </el-col>
                    <el-col :span="14">
                        <div class="seypay-card">
                            <div class="seypay-card__title">Thông tin chuyển khoản</div>
                            <el-alert
                                v-if="!bankTransferOption"
                                :closable="false"
                                class="mb-2"
                                show-icon
                                title="Chưa có thông tin tài khoản nhận tiền để tạo hướng dẫn."
                                type="warning"
                            />

                            <div v-else class="seypay-info">
                                <div class="seypay-info__row">
                                    <div class="seypay-info__label">Ngân hàng</div>
                                    <div class="seypay-info__value">{{ bankTransferOption.bank_name }}</div>
                                </div>
                                <div class="seypay-info__row">
                                    <div class="seypay-info__label">Chủ tài khoản</div>
                                    <div class="seypay-info__value">{{ bankTransferOption.bank_account_name }}</div>
                                </div>
                                <div class="seypay-info__row">
                                    <div class="seypay-info__label">Số tài khoản</div>
                                    <div class="seypay-info__value seypay-info__value--copy">
                                        <span class="seypay-mono">{{ bankTransferOption.bank_account_number }}</span>
                                        <el-button size="mini" type="text"
                                                   @click="copyText(bankTransferOption.bank_account_number, 'Đã sao chép số tài khoản')">
                                            Sao chép
                                        </el-button>
                                    </div>
                                </div>
                                <div class="seypay-info__row seypay-info__row--highlight">
                                    <div class="seypay-info__label">Nội dung CK</div>
                                    <div class="seypay-info__value seypay-info__value--copy">
                                        <span class="seypay-mono">{{ `SF${bankTransferDescription}` }}</span>
                                        <el-button size="mini" type="text"
                                                   @click="copyText(`SF${bankTransferDescription}`, 'Đã sao chép nội dung chuyển khoản')">
                                            Sao chép
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <el-alert
                            :closable="false"
                            :description="'Trung tâm không chịu trách nhiệm nếu trong quá trình chuyển khoản sai thông tin. Trong một số tình huống cụ thể, khách hàng có thể nhờ phía Ngân hàng thực hiện chuyển khoản hoặc Ngân hàng thụ hưởng của trung tâm để kiểm tra đối chứng cần thiết. Ngay khi nhận được xác nhận từ Ngân hàng, trung tâm sẽ tiến hành thủ tục tiếp theo cho khách hàng.'"
                            :title="'Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền'"
                            class="mt-3"
                            show-icon
                            type="success"
                        />
                    </el-col>
                </el-row>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button class="button-cancel" @click="showBankTransferDialog = false">Đóng</el-button>
            </div>
        </el-dialog>

        <el-dialog
            v-if="showDetailDialog"
            :show-close="false"
            :title="`Chi tiết đăng ký thi: ${detailRecord?.studentName || ''}`"
            :visible.sync="showDetailDialog"
            width="55%"
        >
            <hr style="padding: 0; margin-top: -20px"/>
            <div class="table-responsive">
                <table class="table table-bordered">
                    <tbody>
                    <tr>
                        <td style="width: 180px"><b>Mã log</b></td>
                        <td>{{ detailRecord?.logCode }}</td>
                    </tr>
                    <tr>
                        <td><b>Học viên</b></td>
                        <td>{{ detailRecord?.studentName }} <span
                            v-if="detailRecord?.studentCode">- {{ detailRecord?.studentCode }}</span></td>
                    </tr>
                    <tr>
                        <td><b>SĐT</b></td>
                        <td>{{ detailRecord?.phone }}</td>
                    </tr>
                    <tr>
                        <td><b>Chi nhánh</b></td>
                        <td>{{ detailRecord?.branchName }}</td>
                    </tr>
                    <tr>
                        <td><b>Đơn vị thi</b></td>
                        <td>{{ detailRecord?.examUnit }}</td>
                    </tr>
                    <tr>
                        <td><b>Số tiền đóng</b></td>
                        <td>{{ formatCurrency(detailRecord?.payment_amount) }}</td>
                    </tr>
                    <tr>
                        <td><b>Số tiền cho IDP</b></td>
                        <td>{{ formatCurrency(detailRecord?.idp_payment_amount) }}</td>
                    </tr>
                    <tr>
                        <td><b>Hình thức thanh toán</b></td>
                        <td>{{ paymentMethodLabel(detailRecord?.paymentMethod) }}</td>
                    </tr>
                    <tr>
                        <td><b>Địa chỉ</b></td>
                        <td style="text-align: start">{{ detailRecord?.studentAddress || "—" }}</td>
                    </tr>
                    <tr>
                        <td><b>Khu vực chuyển khoản IDP</b></td>
                        <td>{{ detailRecord?.idpTransferArea || "—" }}</td>
                    </tr>
                    <tr>
                        <td><b>Thời hạn chuyển IDP</b></td>
                        <td>{{ detailRecord?.idpDueAt | formatDate }}</td>
                    </tr>
                    <tr>
                        <td><b>Ghi chú</b></td>
                        <td style="text-align: start">{{ detailRecord?.note || "—" }}</td>
                    </tr>
                    <tr>
                        <td><b>Trạng thái</b></td>
                        <td><span :class="detailRecord?.paymentStatusClass" class="pay-status-badge">{{
                                detailRecord?.paymentStatusLabel
                            }}</span></td>
                    </tr>
                    <tr>
                        <td><b>Thời gian sinh tác vụ</b></td>
                        <td>{{ detailRecord?.taskTime }}</td>
                    </tr>
                    <tr>
                        <td><b>Thời gian đóng phí (mới nhất)</b></td>
                        <td>
                            <template v-if="detailRecord?.paidAt">
                                {{ detailRecord.paidAtDisplay || detailRecord.paidAt }}
                            </template>
                            <span v-else class="text-muted">—</span>
                        </td>
                    </tr>
                    <tr v-if="detailRecord?.paymentEntries?.length">
                        <td><b>Lịch sử thanh toán</b></td>
                        <td class="payment-history-cell">
                            <PaymentHistoryPanel
                                :entries="detailRecord.paymentEntries"
                                :hint="!isTransferMethod(detailRecord?.paymentMethod)
                                    ? 'Tiền mặt / quẹt thẻ không có mã giao dịch chuyển khoản.'
                                    : ''"
                                :show-transaction-code="isTransferMethod(detailRecord?.paymentMethod)"
                                title=""
                                @copy="copyText($event, 'Đã sao chép mã giao dịch')"
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 10px">
                <el-button class="button-cancel" @click="showDetailDialog = false">Đóng</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :visible.sync="showFixPaymentDialog"
            append-to-body
            custom-class="fix-payment-dialog"
            title="Xử lý lỗi thanh toán"
            width="520px"
            @close="onCloseFixPaymentDialog"
        >
            <div v-loading="fixPaymentLoading">
                <div style="line-height: 1.5">
                    <div><b>Khách hàng:</b> {{ fixPaymentRecord?.studentName || "—" }}</div>
                    <div v-if="fixPaymentOption">
                        <b>Số tiền cần thanh toán:</b>
                        {{ formatCurrency(fixPaymentOption?.payment_amount) }}
                    </div>
                </div>

                <div class="mt-2">
                    <div class="mb-1">Đánh dấu đã nhận thanh toán</div>
                    <el-select v-model="fixPaymentForm.result" class="w-100" disabled>
                        <el-option v-for="opt in fixPaymentResultOptions" :key="opt.value" :label="opt.label"
                                   :value="opt.value"/>
                    </el-select>
                </div>

                <div class="text-danger mt-2" style="font-weight: 600; word-break: auto-phrase">
                    Lưu ý: Nếu đánh dấu đã xử lý hệ thống sẽ đánh dấu log đóng tiền này của khách hàng là đã thanh toán.
                </div>

                <div class="mt-2">
                    <div class="mb-1">Nhập số tiền khách hàng đã thanh toán <span class="text-danger">*</span></div>
                    <el-input
                        :value="formatFixPaymentAmount(fixPaymentForm.amount)"
                        clearable
                        placeholder="Nhập số tiền đã nhận"
                        @input="onFixPaymentAmountInput"
                    />
                </div>

                <div v-if="fixPaymentLogs.length" class="mt-2">
                    <el-button type="text" @click="fixPaymentShowLogs = !fixPaymentShowLogs">
                        {{ fixPaymentShowLogs ? "Ẩn log" : "Xem log" }}
                    </el-button>

                    <div v-if="fixPaymentShowLogs" style="overflow-x: auto; max-height: 240px; overflow-y: auto">
                        <table class="table table-bordered table-sm">
                            <thead>
                            <tr>
                                <th v-for="col in fixPaymentLogColumns" :key="col" style="white-space: nowrap">{{
                                        col
                                    }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(log, idx) in fixPaymentLogs" :key="idx">
                                <td v-for="col in fixPaymentLogColumns" :key="col + idx">{{
                                        formatLogCell(log[col])
                                    }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="button-cancel" @click="showFixPaymentDialog = false">Hủy bỏ</el-button>
                <el-button
                    :disabled="fixPaymentSubmitting"
                    :loading="fixPaymentSubmitting"
                    style="background: #5e00b6; color: white; border-color: #5e00b6"
                    type="primary"
                    @click="submitFixPayment(fixPaymentRecord)"
                >
                    Xác nhận
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import HeaderManageIdpExamRegister from "./component/HeaderManageIdpExamRegister.vue";
import DialogImportIdpExamRegister from "./component/DialogImportIdpExamRegister.vue";
import FormIdpExamRegister from "./component/FormIdpExamRegister.vue";
import PaymentHistoryPanel from "./component/PaymentHistoryPanel.vue";
import {IdpExamRegisterModel, STATUS_OPTIONS} from "./model/IdpExamRegisterModel";
import {HANDLE_RETEST_ERROR_PAYMENT} from "@/core/services/store/examSchedule/examSchedule";
import {
    GET_IDP_EXAM_REGISTER_DETAIL,
    GET_LIST_IDP_EXAM_REGISTER
} from "@/core/services/store/idp-exam-register/idpExamRegister.module";

export default {
    name: "IdpExamRegisterList",
    components: {
        HeaderManageIdpExamRegister,
        DialogImportIdpExamRegister,
        FormIdpExamRegister,
        PaymentHistoryPanel,
    },
    data() {
        return {
            loading: false,
            showImport: false,
            titleDialogImportIdp: "Import phí thi IDP",
            showCreate: false,
            showDetailDialog: false,
            detailRecord: null,
            showBankTransferDialog: false,
            bankTransferQrCode: "",
            bankTransferOption: null,
            bankTransferAmount: null,
            bankTransferDescription: "",
            bankTransferPayLink: "",
            bankTransferCenterName: "Trung tâm",

            showFixPaymentDialog: false,
            fixPaymentLoading: false,
            fixPaymentSubmitting: false,
            fixPaymentRecord: null,
            fixPaymentOption: null,
            fixPaymentDetail: null,
            fixPaymentLogs: [],
            fixPaymentShowLogs: false,
            fixPaymentForm: {
                result: "accept",
                amount: "",
            },
            fixPaymentResultOptions: [{value: "accept", label: "Đã nhận thanh toán"}],

            page: 1,
            lastPage: 1,
            total: 0,
            records: [],
            statusOptions: STATUS_OPTIONS,
            query: {
                keyword: null,
                time_range: null,
                status: [],
            },
        };
    },
    computed: {
        fixPaymentLogColumns() {
            if (!this.fixPaymentLogs.length) return [];
            const keys = new Set();
            this.fixPaymentLogs.forEach((row) => {
                if (row && typeof row === "object") Object.keys(row).forEach((k) => keys.add(k));
            });
            return Array.from(keys);
        },
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý tài chính"},
            {title: "Quản lý phí khác"},
            {title: "Phí IDP"},
        ]);
        this.reloadList();
    },
    methods: {
        openImportDialog() {
            this.titleDialogImportIdp = "Import phí thi IDP";
            this.showImport = true;
        },
        setImportDialogTitle(title) {
            this.titleDialogImportIdp = title;
        },
        formatCurrency(amount) {
            const num = Number(amount);
            return isNaN(num) ? amount : num.toLocaleString("vi-VN") + " đ";
        },
        formatFixPaymentAmount(amount) {
            const num = Number(amount);
            return isNaN(num) || amount === "" ? "" : num.toLocaleString("vi-VN");
        },
        onCloseFixPaymentDialog() {
            this.fixPaymentRecord = null;
            this.fixPaymentOption = null;
            this.fixPaymentDetail = null;
            this.fixPaymentLogs = [];
            this.fixPaymentForm.amount = "";
            this.fixPaymentShowLogs = false;
            this.fixPaymentSubmitting = false;
        },
        formatLogCell(val) {
            if (val === null || val === undefined) return "—";
            if (typeof val === "object") return JSON.stringify(val);
            return val;
        },
        paymentMethodLabel(method) {
            switch ((method || "").toString()) {
                case "cash":
                    return "Tiền mặt";
                case "transfer":
                    return "Chuyển khoản";
                case "card":
                    return "Quẹt thẻ";
                default:
                    return method || "";
            }
        },
        isTransferMethod(method) {
            return (method || "").toString() === "transfer";
        },
        transactionCodesForItem(item) {
            return (item?.paymentEntries || []).map((e) => e.code).filter(Boolean);
        },
        inlineTransactionCode(item) {
            if (!this.isTransferMethod(item?.paymentMethod)) return "";
            const codes = this.transactionCodesForItem(item);
            return item?.hasMultiplePayments ? "" : (codes[0] || "");
        },
        showPaymentHistoryPopover(item) {
            return Boolean(item?.hasMultiplePayments && item?.paymentEntries?.length);
        },
        copyText(text, successMsg = "Đã sao chép") {
            const value = (text ?? "").toString();
            if (!value) return;
            if (navigator?.clipboard?.writeText) {
                navigator.clipboard.writeText(value).then(() => {
                    this.$message.success(successMsg);
                }).catch(() => {
                    this.$message.warning("Không thể sao chép tự động. Vui lòng sao chép thủ công.");
                });
            } else {
                this.$message.warning("Trình duyệt không hỗ trợ sao chép tự động.");
            }
        },
        handleCreated(payload) {
            this.reloadList();
            const method = payload?.payment_method;
            if (method !== "transfer") return;

            const record = payload?.record || {};
            const payment = record?.payment || record?.data?.payment || null;
            const centerId = record?.center_id ?? record?.data?.center_id ?? null;
            this.bankTransferCenterName = Number(centerId) === 295 ? "ECoach" : "IELTS Mentor";
            this.bankTransferOption = payment;
            this.bankTransferAmount = payment?.payment_amount ?? record?.payment_amount ?? null;

            const bank = (payment?.bank_name || "").toString().trim();
            const acc = (payment?.bank_account_number || "").toString().trim();
            const des = (payment?.payment_code || record?.payment_code || record?.code || "").toString().trim();
            this.bankTransferDescription = des;
            this.bankTransferPayLink = this.buildPaymentLink(centerId, des);

            if (bank && acc && des) {
                const desContent = `SF${des}`
                let url = `https://qr.sepay.vn/img?bank=${encodeURIComponent(bank)}&acc=${encodeURIComponent(acc)}&template=compact&des=${encodeURIComponent(desContent)}`;
                if (this.bankTransferAmount) url += `&amount=${encodeURIComponent(this.bankTransferAmount)}`;
                this.bankTransferQrCode = url;
            } else {
                this.bankTransferQrCode = "";
            }
            this.showBankTransferDialog = true;
        },
        buildPaymentLink(centerId, paymentCode) {
            const code = (paymentCode || "").toString().trim();
            if (!code) return "";
            // Theo yêu cầu: IELTS Mentor dùng link.ieltsmentor, EC (ECoach) dùng link.classup
            const base = Number(centerId) === 295
                ? "https://payment.ecoach.vn/?payment_option="
                : "https://payment.ieltsmentor.edu.vn/?payment_option=";
            return `${base}${encodeURIComponent(`SF${code}`)}`;
        },
        async openFixPaymentDialog(item) {
            this.fixPaymentRecord = item;
            const row = item?.raw ?? item ?? {};
            const payment = row?.payment ?? null;
            this.fixPaymentOption = payment;
            this.showFixPaymentDialog = true;
            this.fixPaymentLoading = true;
            this.fixPaymentDetail = null;
            this.fixPaymentLogs = [];
            this.fixPaymentShowLogs = false;
            this.fixPaymentForm.result = "accept";
            this.fixPaymentForm.amount = "";
            try {
                const res = await this.$store.dispatch(GET_IDP_EXAM_REGISTER_DETAIL, {id: item.id});
                if (res?.error) {
                    this.$message.error(res?.message || "Không tải được chi tiết");
                    this.fixPaymentDetail = row;
                    return;
                }
                const data = res?.data ?? res;
                this.fixPaymentDetail = data;
                this.fixPaymentOption = data?.payment ?? payment;
                const logs =
                    data?.payment_logs ??
                    data?.paymentLogs ??
                    data?.payment_history ??
                    data?.logs ??
                    null;
                this.fixPaymentLogs = Array.isArray(logs) ? logs : [];
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                this.$message.error("Không tải được chi tiết đăng ký thi IDP");
                this.fixPaymentDetail = row;
            } finally {
                this.fixPaymentLoading = false;
            }
        },
        onFixPaymentAmountInput(value) {
            const raw = String(value || "").replace(/\D/g, "");
            this.fixPaymentForm.amount = raw ? Number(raw) : "";
        },
        async submitFixPayment(item) {
            const amount = this.fixPaymentForm.amount;
            if (!amount || Number(amount) < 1) {
                return this.$notify({
                    title: "Thiếu dữ liệu!",
                    message: "Vui lòng nhập số tiền khách hàng đã thanh toán!",
                    type: "warning",
                });
            }
            const id = item?.id;
            if (!id) {
                return this.$notify.error({
                    title: "Thiếu dữ liệu!",
                    message: "Không xác định được log thanh toán để xử lý.",
                });
            }

            this.fixPaymentSubmitting = true;
            try {
                const res = await this.$store.dispatch(HANDLE_RETEST_ERROR_PAYMENT, {
                    id,
                    amount_paid: Number(amount),
                    type: "idp_exam",
                });
                this.$notify({
                    title: "Success",
                    message: res?.message || "Xử lý lỗi thanh toán thành công!",
                    type: "success",
                });
                this.showFixPaymentDialog = false;
                await this.reloadList();
            } catch (e) {
                this.$notify.error({
                    title: "Có lỗi xảy ra!",
                    message: e?.data?.message || "Xử lý lỗi thanh toán thất bại!",
                });
            } finally {
                this.fixPaymentSubmitting = false;
            }
        },
        async openPaymentGuide(item) {
            const row = item?.raw ?? item ?? {};
            this.bankTransferOption = null;
            this.bankTransferQrCode = "";
            this.bankTransferAmount = row?.payment_amount ?? null;
            this.bankTransferDescription = (row?.payment_code ?? "").toString().trim();
            this.bankTransferPayLink = "";
            this.bankTransferCenterName = "Trung tâm";

            try {
                const res = await this.$store.dispatch(GET_IDP_EXAM_REGISTER_DETAIL, {id: item.id});
                if (res?.error) {
                    this.$message.error(res?.message || "Không tải được chi tiết");
                } else {
                    const d = res?.data ?? res;
                    const centerId = d?.center_id ?? d?.data?.center_id ?? null;
                    this.bankTransferCenterName = Number(centerId) === 295 ? "ECoach" : "IELTS Mentor";
                    const payment = d?.payment ?? null;
                    const code = (payment?.payment_code || d?.payment_code || d?.code || this.bankTransferDescription || "").toString().trim();
                    this.bankTransferOption = payment;
                    this.bankTransferAmount = payment?.payment_amount ?? d?.payment_amount ?? this.bankTransferAmount;
                    this.bankTransferDescription = code;
                    this.bankTransferPayLink = this.buildPaymentLink(centerId, code);

                    const bank = (payment?.bank_name || "").toString().trim();
                    const acc = (payment?.bank_account_number || "").toString().trim();
                    if (bank && acc && code) {
                        const desContent = `SF${code}`
                        let url = `https://qr.sepay.vn/img?bank=${encodeURIComponent(bank)}&acc=${encodeURIComponent(acc)}&template=compact&des=${encodeURIComponent(desContent)}`;
                        if (this.bankTransferAmount) url += `&amount=${encodeURIComponent(this.bankTransferAmount)}`;
                        this.bankTransferQrCode = url;
                    }
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            } finally {
                this.showBankTransferDialog = true;
            }
        },
        openDetail(item) {
            this.detailRecord = item;
            this.showDetailDialog = true;
        },
        changePage(p) {
            this.page = p;
            this.reloadList();
        },
        parseStatusFromQuery(status) {
            if (status === undefined || status === null || status === "") return [];
            if (Array.isArray(status)) {
                return status.map((s) => Number(s)).filter((n) => !isNaN(n));
            }
            try {
                return JSON.parse(`[${status}]`).map((s) => Number(s)).filter((n) => !isNaN(n));
            } catch {
                const n = Number(status);
                return isNaN(n) ? [] : [n];
            }
        },
        statusQueryForApi() {
            return Array.isArray(this.query.status) && this.query.status.length ? this.query.status : null;
        },
        async pushParams() {
            await this.$router.push({
                name: "IdpExamRegisterList",
                query: {
                    ...this.query,
                    status: this.statusQueryForApi(),
                    from_date: this.query.time_range?.[0] ?? null,
                    to_date: this.query.time_range?.[1] ?? null,
                },
            });
        },
        getParams() {
            const q = this.$route.query || {};
            this.query.keyword = q.keyword ?? null;
            this.query.status = this.parseStatusFromQuery(q.status);
            const from = q.from_date ?? null;
            const to = q.to_date ?? null;
            this.query.time_range = from && to ? [from, to] : null;
        },
        async handleSearch() {
            this.page = 1;
            await this.pushParams();
            this.reloadList();
        },
        async reloadList() {
            this.getParams();
            this.loading = true;
            try {
                const payload = {
                    page: this.page,
                    per_page: 20,
                    keyword: this.query.keyword,
                    status: this.statusQueryForApi(),
                    from_date: this.query.time_range?.[0] ?? null,
                    to_date: this.query.time_range?.[1] ?? null,
                };
                const res = await this.$store.dispatch(GET_LIST_IDP_EXAM_REGISTER, payload);
                if (!res?.error) {
                    const pageObj = res?.data?.data ? res.data : (res?.pagination ? res.pagination : res?.data);
                    const rows = pageObj?.data ?? res?.data ?? [];
                    this.page = pageObj?.current_page ?? this.page;
                    this.lastPage = pageObj?.last_page ?? 1;
                    this.total = pageObj?.total ?? 0;
                    this.records = (Array.isArray(rows) ? rows : []).map((r) => new IdpExamRegisterModel(r));
                } else {
                    this.records = [];
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
                this.records = [];
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.display-flex-column {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.grid-filter {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
    .grid-filter {
        grid-template-columns: 1fr 1fr;
        gap: 10px 30px;
    }
}

.status-badge {
    display: inline-block;
    padding: 5px 8px;
    border-radius: 5px;
    color: white;
    font-weight: 600;
}

.status-unpaid {
    background: #f59e0b;
}

.status-paid {
    background: #3b82f6;
}

.status-done {
    background: #10b981;
}

.status-missing {
    background: #ef4444;
}

.pay-status-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.pay-paid {
    background: #d1fae5;
    color: #065f46;
}

.pay-unpaid {
    background: #fef3c7;
    color: #92400e;
}

.pay-shortage {
    background: #fee2e2;
    color: #991b1b;
}

.payment-time-cell {
    text-align: start;
    vertical-align: middle;
}

.payment-time-cell__main {
    font-weight: 500;
    color: #111827;
    line-height: 1.4;
}

.payment-history-trigger {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
    padding: 2px 8px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: #f9fafb;
    color: #5e00b6;
    font-size: 12px;
    cursor: pointer;
    line-height: 1.4;
}

.payment-history-trigger:hover {
    background: #f3e8ff;
    border-color: #c4b5fd;
}

.payment-tx-inline {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
    max-width: 200px;
}

.payment-tx-inline__label {
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.02em;
    color: #9ca3af;
}

.payment-tx-inline__code {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
    color: #4b5563;
    background: #f3f4f6;
    padding: 2px 6px;
    border-radius: 4px;
}

.text-muted {
    color: #9ca3af;
}

.button-cancel {
    background: #cacaca;
    color: black;
}

.button-cancel:hover {
    color: white;
    opacity: 90%;
}

.seypay-wrapper {
    padding-top: 4px;
}

.seypay-summary {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 12px;
}

.seypay-card {
    border: 1px solid #EBEDF3;
    border-radius: 10px;
    background: #fff;
    padding: 12px;
}

.seypay-card__title {
    font-weight: 600;
    color: #111827;
    margin-bottom: 10px;
}

.seypay-qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.seypay-qr__img {
    width: 280px;
    max-width: 100%;
    border-radius: 10px;
    border: 1px solid #F1F5F9;
}

.seypay-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.seypay-info__row {
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 10px;
    align-items: start;
}

.seypay-info__label {
    color: #6B7280;
    font-size: 12px;
}

.seypay-info__value {
    color: #111827;
    font-size: 13px;
    font-weight: 500;
    word-break: break-word;
}

.seypay-paylink {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    border: 1px solid #E5E7EB;
    border-radius: 10px;
    background: #F9FAFB;
    margin-bottom: 12px;
}

.seypay-info__value--copy {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
}

.seypay-info__value--copy .el-button {
    padding: 0;
    font-weight: 600;
}

.seypay-info__row--highlight .seypay-info__value {
    background: #F5F3FF;
    border: 1px solid #EDE9FE;
    padding: 8px 10px;
    border-radius: 10px;
}

.seypay-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

@media screen and (max-width: 992px) {
    .seypay-info__row {
        grid-template-columns: 1fr;
    }

    .seypay-info__value--copy {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>

<style>
/* append-to-body: dialog nằm ngoài scoped của trang */
.el-dialog.dialog-idp-register {
    border-radius: 8px;
    overflow: hidden;
}

.el-dialog.dialog-idp-register .el-dialog__header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #ebedf3;
}

.el-dialog.dialog-idp-register .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 1.35;
}

.el-dialog.dialog-idp-register .el-dialog__body {
    padding: 12px 20px 20px;
}

.el-dialog.dialog-idp-register .el-dialog__footer {
    padding: 0;
}

.idp-payment-history-popover {
    padding: 12px 14px;
    box-sizing: border-box;
    max-width: min(420px, calc(100vw - 24px));
    overflow: hidden;
}

.idp-payment-history-popover .payment-history-panel {
    min-width: 0;
}

.payment-history-cell {
    max-width: 0;
    width: 100%;
    overflow: hidden;
    vertical-align: top;
}
</style>

